var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.99984 18.3346C14.6022 18.3346 18.3332 14.6037 18.3332 10.0013C18.3332 5.39893 14.6022 1.66797 9.99984 1.66797C5.39746 1.66797 1.6665 5.39893 1.6665 10.0013C1.6665 14.6037 5.39746 18.3346 9.99984 18.3346Z",
    fill: "#60646C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1249 8.94036V8.33203C13.1249 7.55703 13.1249 5.20703 9.99994 5.20703C6.87494 5.20703 6.87494 7.55703 6.87494 8.33203V8.94036C5.85827 9.16536 5.5166 9.8237 5.5166 11.2487V12.082C5.5166 13.9154 6.08327 14.482 7.91661 14.482H12.0833C13.9166 14.482 14.4833 13.9154 14.4833 12.082V11.2487C14.4833 9.8237 14.1416 9.16536 13.1249 8.94036ZM9.99994 12.582C9.49161 12.582 9.08329 12.1737 9.08329 11.6654C9.08329 11.157 9.49161 10.7487 9.99994 10.7487C10.5083 10.7487 10.9166 11.157 10.9166 11.6654C10.9166 12.1737 10.5083 12.582 9.99994 12.582ZM11.8749 8.84869H8.12494V8.33203C8.12494 7.11536 8.42494 6.45703 9.99994 6.45703C11.5749 6.45703 11.8749 7.11536 11.8749 8.33203V8.84869Z",
    fill: "#60646C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircle);
export default __webpack_public_path__ + "static/media/lock-circle.82dbf9bac1b2b9cb7b723fc7a4fac930.svg";
export { ForwardRef as ReactComponent };